import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScrollHorizontal = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "scroll-horizontal" }),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 11.998,
			r: 2.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.311,18l-5.25-5.25a1.059,1.059,0,0,1,0-1.5L6.311,6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M17.689,6l5.25,5.25a1.061,1.061,0,0,1,0,1.5L17.689,18"
		})
	]
});
export default SvgScrollHorizontal;
